import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { sizeUnits } from "./items";

export const itemDocSerializer = Serializers.object({
  ...baseDocSerializer("item").fields,

  itemId: Serializers.string,
  productId: Serializers.string,
  itemName: Serializers.string,
  gtin: Serializers.string.nullable(),
  box: Serializers.integer.nullable(),
  layer: Serializers.integer.nullable(),
  pallet: Serializers.integer.nullable(),
  size: Serializers.decimal,
  sizeUnit: Serializers.stringOneOf(...sizeUnits),
  massKg: Serializers.decimal,
  bcId: uuidSerializer.nullable(),
  productGroup: Serializers.string,
  title: Serializers.string,
  variantTitle: Serializers.string,
  brand: Serializers.string,
  description: Serializers.string,
  handle: Serializers.string.nullable(),
  shopifyVariantId: Serializers.string.nullable(),
  shopifyProductId: Serializers.string.nullable(),
  cost: Serializers.decimal.nullable(),
  isLoyalty: Serializers.boolean,
  defaultProfit: Serializers.decimal.nullable(),
  isInAvailability: Serializers.boolean,
});

export type ItemDoc = SerializerValue<typeof itemDocSerializer>;
